module.exports = __webpack_public_path__ + "28b67065/img/ion_calendar-number.3ac5bd07.svg";